<template>
  <div>
    <div class="col-md-12 m-0 p-2">
      <!-- <div class="text-right mb-2 px-2">
         <p @click="fetchLatestCount" class="btn btn-link m-0 p-0">Fetch latest</p>
      </div> -->
      <div class="mb-5">
        <h1>Hi, {{username}}</h1>
      </div>
      <b-row class="mb-2">
        <b-col md="8" sm="12">
          <b-row>
            <b-col sm="12" md="6" class="mb-4">
              <b-card body-class="" class="p-0 m-0 border-0 shadow-sm">
                <b-row>
                  <b-col class="my-auto pl-4">
                    <b-icon
                      icon="info-circle"
                      scale="2"
                      variant="success"
                    ></b-icon>
                  </b-col>
                  <b-col class="pb-2 text-right">
                    <p class="m-0 p-0">Total Vehicle</p>
                    <h1 class="m-0 p-0">
                      <strong>{{ totalVehicle }}</strong>
                    </h1>
                  </b-col>
                </b-row>
                <div class="text-left m-0 p-0">
                  <hr class="m-0 p-0 pt-2" />
                  <p class="label m-0 p-0">
                    + {{ returned }} Returned, {{ notWorking }} Not Working
                  </p>
                </div>
              </b-card>
            </b-col>
            <b-col sm="12" md="6" class="mb-4">
              <b-card body-class="" class="p-0 m-0 border-0 shadow-sm">
                <b-row>
                  <b-col class="my-auto pl-4">
                    <b-icon
                      icon="stop-circle"
                      scale="2"
                      variant="danger"
                    ></b-icon>
                  </b-col>
                  <b-col class="pb-2 text-right">
                    <p class="m-0 p-0">Active Booking</p>
                    <h1 class="m-0 p-0">
                      <strong>{{ booked }}</strong>
                    </h1>
                  </b-col>
                </b-row>
                <div class="text-left m-0 p-0">
                  <hr class="m-0 p-0 pt-2" />
                  <p class="label m-0 p-0">+ {{ newBooking }} New Booking</p>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="mb-4">
          <b-card body-class="" class="p-0 m-0 border-0 shadow-sm">
            <b-row>
              <b-col class="my-auto pl-4">
                <b-icon icon="pause-circle" scale="2" variant="info"></b-icon>
              </b-col>
              <b-col class="pb-2 text-right">
                <p class="m-0 p-0">Unoccupied Vehicle</p>
                <h1 class="m-0 p-0">
                  <strong>{{ available }}</strong>
                </h1>
              </b-col>
            </b-row>
            <div class="text-left m-0 p-0">
              <hr class="m-0 p-0 pt-2" />
              <p class="label m-0 p-0">
                +
                {{ ongoingUnderservice + underService + UnderWaterWash }}
                Servicing
              </p>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8" class="mb-4">
          <b-card class="col-md-12 mx-auto border-0 p-0 shadow-sm">
            <p class="text-muted">Daily Active Bookings
              <span
              v-b-tooltip.hover
              title="The active booking for the day, calculated for booking prevailed for 24 hours."
              ><i class="fal fa-info-circle"></i>
              </span>
            </p>
            <dailybooking></dailybooking>
          </b-card>
        </b-col>
        <b-col md="4" class="mb-4">
          <b-card class="col-md-12 mx-auto m-0 border-0 p-0 shadow-sm">
            <p class="text-muted">Customer Retention Behavior
              <span
              v-b-tooltip.hover
              title="Booking Active on a monthly basis."
              ><i class="fal fa-info-circle"></i>
              </span>
            </p>
            <customerRetention></customerRetention>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8" class="mb-4">
          <b-card class="col-md-12 mx-auto border-0 p-0 shadow-sm">
          <p class="text-muted">Drop vs Pickup</p>
          <dropvspick></dropvspick>
        </b-card>
        </b-col>
        <b-col md="4">
         <b-card class="col-md-12 mx-auto m-0 border-0 p-0 shadow-sm">
            <p class="text-muted">TP Leaderboard
              <span
              v-b-tooltip.hover
              title="Lederboard is calculated with the maximum touch point by any agent."
              ><i class="fal fa-info-circle"></i>
              </span>
            </p>
            <leaderboard></leaderboard>
         </b-card>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col md="4" class="mb-4">
          <b-card class="col-md-12 mx-auto m-0 border-0 p-0 shadow-sm">
            <p class="text-muted">Booking Success</p>
            <sourcewisestats></sourcewisestats>
          </b-card>
        </b-col>
        <b-col md="4" class=" mb-4">
          <b-card class="col-md-12 mx-auto m-0 border-0 p-0 shadow-sm">
            <p class="text-muted">Booking Failure</p>
            <failureSourceStats></failureSourceStats>
          </b-card>
        </b-col>
        <b-col md="4" class="mb-4">
          <b-card class="col-md-12 mx-auto m-0 border-0 p-0 shadow-sm">
            <p class="text-muted">Vehicles Stats</p>
            <vehicleGraph></vehicleGraph>
          </b-card>
        </b-col>
      </b-row>
      <!-- <b-row>
        
      </b-row> -->
    </div>
    <div class="text-center mt-5">
      <p class="text-muted">Made by Ontrack Labs, SF</p>
    </div>
  </div>
</template>

<script>
import dropvspick from "../components/homepage/views/dropvspick.vue";
import dailybooking from "../components/homepage/views/dailyBooking.vue";
import sourcewisestats from "./homepage/views/successSourceStats.vue";
import failureSourceStats from "../components/homepage/views/failureSourceStats.vue";
import customerRetention from "../components/homepage/views/customerRetention.vue";
import vehicleGraph from "../components/homepage/views/vehicleGraph.vue";
import leaderboard from "../components/homepage/views/leaderBoard.vue";

export default {
  components: {
    dropvspick,
    sourcewisestats,
    failureSourceStats,
    customerRetention,
    dailybooking,
    vehicleGraph,
    leaderboard
  },
  created() {
    this.loadVehicle();
  },
  methods: {
    loadVehicle() {
      this.$store.dispatch("get_vehicle_count");
    },
    fetchLatestCount() {
      this.$store.state.vehicle_count = [];
      this.loadVehicle();
    },
  },
  computed: {
    username() {
      return this.$store.getters.userName || "Anonymous";
    },
    vehicle_count() {
      return this.$store.state.vehicle_count;
    },

    totalVehicle() {
      return this.totalVehicles - (this.returned + this.notWorking) || 0;
    },
    available() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].available != null) {
          count += this.vehicle_count[i].available;
        }
      }
      return count;
    },
    totalVehicles() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].total != null) {
          count += this.vehicle_count[i].total;
        }
      }
      return count || 0;
    },
    booked() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].booked != null) {
          count += this.vehicle_count[i].booked;
        }
      }
      return count || 0;
    },
    newBooking() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].newBooking != null) {
          count += this.vehicle_count[i].newBooking;
        }
      }
      return count || 0;
    },
    underService() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].underService != null) {
          count += this.vehicle_count[i].underService;
        }
      }
      return count;
    },
    ongoingUnderservice() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].ongoingUnderservice != null) {
          count += this.vehicle_count[i].ongoingUnderservice;
        }
      }
      return count;
    },
    notWorking() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].not_working != null) {
          count += this.vehicle_count[i].not_working;
        }
      }
      return count;
    },
    UnderWaterWash() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].UnderWaterWash != null) {
          count += this.vehicle_count[i].UnderWaterWash;
        }
      }
      return count;
    },
    returned() {
      var count = 0;
      for (var i in this.vehicle_count) {
        if (this.vehicle_count[i].returned != null) {
          count += this.vehicle_count[i].returned;
        }
      }
      return count;
    },
  },
};
</script>

<style>
.label {
  color: gray;
  font-size: 0.75rem;
  font-weight: 400;
}
.icons {
  font-size: 30px;
}
.icons-container {
  height: 50px;
  width: 50px;
  border-radius: 50%;
  background: #e14eca;
  background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
  background-size: 210% 210%;
  background-position: 100% 0;
}
</style>
